import { CareerRole_MerchandisingJobCategory as JobCategory } from '__generated__/graphql-types';

import type { KnownDomainSlugs } from 'bundles/browse-common/types/domain';

export function toJobCategory(slug: KnownDomainSlugs) {
  switch (slug) {
    case 'business':
      return JobCategory.Business;
    case 'data-science':
      return JobCategory.DataAndAnalytics;
    case 'health':
      return JobCategory.Healthcare;
    case 'computer-science':
    case 'information-technology':
      return JobCategory.SoftwareAndIt;
    case 'arts-and-humanities':
      return JobCategory.SalesAndMarketing;
    case 'math-and-logic':
    case 'language-learning':
    case 'personal-development':
    case 'physical-science-and-engineering':
    case 'social-sciences':
    default:
      return undefined;
  }
}
